
import axios from "../utils/axios";

// Get all menu items
export const getMenuApi = () =>
  axios.get("/api/menu");

export const addMenuApi = async (data) => {
  return axios.post("/api/menu", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Toggle menu item availability
export const toggleMenuApi = (id) =>
  axios.put(`/api/menu/toggle/${id}`);

// Upload Excel file
export const uploadMenuExcelApi = (formData) =>
  axios.post("/api/menu/upload-excel", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// Update menu item
export const updateMenuApi = async (data) => {
  return axios.put("/api/menu/update", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Delete menu item
export const deleteMenuApi = (id) =>
  axios.delete("/api/menu/delete", { data: { id } });